import { Component, effect, inject, input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { BatchSignal } from '@xanadu/signal';
import { Genus, Folder, Site, Secure, NodeModel } from '@xanadu/model';
import { AuthSignal, TabSignal } from '@xanadu/signal';

@Component({
    selector: 'app-batch-node',
    templateUrl: './batch-node.component.html',
    styleUrls: ['./batch-node.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BatchNodeComponent {
    private readonly authSignal = inject(AuthSignal);
    private readonly batchSignal = inject(BatchSignal);
    private readonly tabSignal = inject(TabSignal);

    model = input<NodeModel>();

    private iconRoot = 'account_tree';
    private iconSite = 'public';
    private iconGenus = 'insert_drive_file';
    private iconFolder = 'folder';

    public icon?: string;

    constructor(
    ) {
        effect(() => {
            const model = this.model();
            const identity = this.authSignal.identity();

            if (identity && model?.batch) {
                const secure = model.node instanceof Secure
                    ? model.node as Secure
                    : undefined;

                if (identity._system) {
                    model.batch.expandable = true;
                } else if (secure) {
                    const permission = secure.permission;
                    if (permission) {
                        const manage = identity.has(permission, 'manage');
                        model.batch.expandable = manage || identity.has(permission, 'list');
                    }
                }
            }

            if (model?.node instanceof Site) {
                this.icon = this.iconSite;
            } else if (model?.node instanceof Folder) {
                this.icon = this.iconFolder;
            } else if (model?.node instanceof Genus) {
                if (model.node.parentId) {
                    this.icon = this.iconGenus;
                } else {
                    this.icon = this.iconRoot;
                }
            }
        });

        effect(() => {
            const id = this.batchSignal.prototype();
            const model = this.model();

            if (model?.batch) {
                model.batch.disabled = !!id?.length && model.info.genus?.prototypeId !== id;
                if (!id?.length) {
                    model.batch.checked = false;
                }
            }
        });
    }

    public onToggle(): void {
        const model = this.model();

        if (model) {
            model.toggleBatch();
            if (!(model.loaded)) {
                this.tabSignal.node.content.set(model);
            }
        }
    }

    public onChange(event: Event) {
        const model = this.model();

        if (model) {
            if (model.loaded) {
                this.batchSignal.toggle(model, model.batch?.checked ?? false);
            } else {
                this.tabSignal.node.content.set(model);
            }
        }
    }

    public onModel(checked: boolean) {
        const batch = this.model()?.batch;

        if (batch) {
            batch.checked = checked;
        }
    }
}
